 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER3201SURPRISEATTACK from '@/components/0_chapter3201surpriseattack'
 import A_CHAPTER3202BIGPROPHECY from '@/components/1_chapter3202bigprophecy'
 import A_CHAPTER3203THEAPPEARANCEOFTHEGODEMPEROR from '@/components/2_chapter3203theappearanceofthegodemperor'
 import A_CHAPTER3204REGRESSIVECHALK from '@/components/3_chapter3204regressivechalk'
 import A_CHAPTER3205TURNAROUND from '@/components/4_chapter3205turnaround'
 import A_CHAPTER3206DUBIOUSSINUS from '@/components/5_chapter3206dubioussinus'
 import A_CHAPTER3207DAUGHTER from '@/components/6_chapter3207daughter'
 import A_CHAPTER3208THETRUTHISCLEAR from '@/components/7_chapter3208thetruthisclear'
 import A_CHAPTER3209DIFFICULTYINFEELING from '@/components/8_chapter3209difficultyinfeeling'
 import A_CHAPTER3210MARCHINGFORMATION from '@/components/9_chapter3210marchingformation'
 import A0_CHAPTER3211SEAL from '@/components/10_chapter3211seal'
 import A1_CHAPTER3212CHALK from '@/components/11_chapter3212chalk'
 import A2_CHAPTER3213SURVIVAL from '@/components/12_chapter3213survival'
 import A3_CHAPTER3214WHEREISTHEBIGMAN from '@/components/13_chapter3214whereisthebigman'
 import A4_CHAPTER3215OFFENSES from '@/components/14_chapter3215offenses'
 import A5_CHAPTER3216PSIONICEMINENCEINPERSON from '@/components/15_chapter3216psioniceminenceinperson'
 import A6_CHAPTER3217ESTRANGEMENTOFLIVINGBEINGS from '@/components/16_chapter3217estrangementoflivingbeings'
 import A7_CHAPTER3218KSITIGARBHA from '@/components/17_chapter3218ksitigarbha'
 import A8_CHAPTER3219PERISTALSIS from '@/components/18_chapter3219peristalsis'
 import A9_CHAPTER3220BODHISATTVAMADEHISMOVE from '@/components/19_chapter3220bodhisattvamadehismove'
 import A0_CHAPTER3221BUDDHISTLIGHT from '@/components/20_chapter3221buddhistlight'
 import A1_CHAPTER3222THEPLAGUEOFGENUINEQI from '@/components/21_chapter3222theplagueofgenuineqi'
 import A2_CHAPTER3223MARGINALMETHOD from '@/components/22_chapter3223marginalmethod'
 import A3_CHAPTER3224RIGIDITY from '@/components/23_chapter3224rigidity'
 import A4_CHAPTER3225ONEWORDDIFFICULT from '@/components/24_chapter3225oneworddifficult'
 import A5_CHAPTER3226BIGPLANOFTHOUSANDYEARS from '@/components/25_chapter3226bigplanofthousandyears'
 import A6_CHAPTER3227COMPROMISEOFAMYGDALA from '@/components/26_chapter3227compromiseofamygdala'
 import A7_CHAPTER3228BAIXIANSSUSPICION from '@/components/27_chapter3228baixianssuspicion'
 import A8_CHAPTER3229WINDRAISING from '@/components/28_chapter3229windraising'
 import A9_CHAPTER3230EMPTYCITY from '@/components/29_chapter3230emptycity'
 import A0_CHAPTER3231OUYANGYU from '@/components/30_chapter3231ouyangyu'
 import A1_CHAPTER3232SWAP from '@/components/31_chapter3232swap'
 import A2_CHAPTER3233POWER from '@/components/32_chapter3233power'
 import A3_CHAPTER3234ODDPOISON from '@/components/33_chapter3234oddpoison'
 import A4_CHAPTER3235SACREDHEART from '@/components/34_chapter3235sacredheart'
 import A5_CHAPTER3236SACRIFICE from '@/components/35_chapter3236sacrifice'
 import A6_CHAPTER3237NOTREDAME from '@/components/36_chapter3237notredame'
 import A7_CHAPTER3238BODYOFSTEEL from '@/components/37_chapter3238bodyofsteel'
 import A8_CHAPTER3239CARDIACTRACE from '@/components/38_chapter3239cardiactrace'
 import A9_CHAPTER3240RESURRECTIONBYDEATH from '@/components/39_chapter3240resurrectionbydeath'
 import A0_CHAPTER3241PRIMORDIALSPIRITORB from '@/components/40_chapter3241primordialspiritorb'
 import A1_CHAPTER3242SEABANK from '@/components/41_chapter3242seabank'
 import A2_CHAPTER3243HOLYLAND from '@/components/42_chapter3243holyland'
 import A3_CHAPTER3244ICHTHYOPHYLLUMMONGOLICUMTHUNB from '@/components/43_chapter3244ichthyophyllummongolicumthunb'
 import A4_CHAPTER3245WATERDROPLET from '@/components/44_chapter3245waterdroplet'
 import A5_CHAPTER3246LIGHTNING from '@/components/45_chapter3246lightning'
 import A6_CHAPTER3247RETURNING from '@/components/46_chapter3247returning'
 import A7_CHAPTER3248COPPERRING from '@/components/47_chapter3248copperring'
 import A8_CHAPTER3249THEHOLYMANMADEHISMOVE from '@/components/48_chapter3249theholymanmadehismove'
 import A9_CHAPTER3250HEAVYFALL from '@/components/49_chapter3250heavyfall'
 import A0_CHAPTER3251TOTALOUTOFCONTROL from '@/components/50_chapter3251totaloutofcontrol'
 import A1_CHAPTER3252COLDFIRE from '@/components/51_chapter3252coldfire'
 import A2_CHAPTER3253FORCEOFDESIRE from '@/components/52_chapter3253forceofdesire'
 import A3_CHAPTER3254OLDMOTHERSHENSHAN from '@/components/53_chapter3254oldmothershenshan'
 import A4_CHAPTER3255WANSHENSSPIRIT from '@/components/54_chapter3255wanshensspirit'
 import A5_CHAPTER3256SIMPLECHASTITYDYING from '@/components/55_chapter3256simplechastitydying'
 import A6_CHAPTER3257EVENTHOUGHHEHADDIEDHEHADNOREGRETS from '@/components/56_chapter3257eventhoughhehaddiedhehadnoregrets'
 import A7_CHAPTER3258NIRVANA from '@/components/57_chapter3258nirvana'
 import A8_CHAPTER3259PALMSTRIKE from '@/components/58_chapter3259palmstrike'
 import A9_CHAPTER3260RESCUE from '@/components/59_chapter3260rescue'
 import A0_CHAPTER3261DIVINEPOWER from '@/components/60_chapter3261divinepower'
 import A1_CHAPTER3262IAMWILLINGTOPARTWITHMYBODY from '@/components/61_chapter3262iamwillingtopartwithmybody'
 import A2_CHAPTER3263INVERTEDUNIVERSE from '@/components/62_chapter3263inverteduniverse'
 import A3_CHAPTER3264LEFTANDRIGHT from '@/components/63_chapter3264leftandright'
 import A4_CHAPTER3265ESCAPE from '@/components/64_chapter3265escape'
 import A5_CHAPTER3266CRUELWORDORDER from '@/components/65_chapter3266cruelwordorder'
 import A6_CHAPTER3267PYRETICBLOOD from '@/components/66_chapter3267pyreticblood'
 import A7_CHAPTER3268CHASTEHEART from '@/components/67_chapter3268chasteheart'
 import A8_CHAPTER3269BLOODMOON from '@/components/68_chapter3269bloodmoon'
 import A9_CHAPTER3270HUMANJUSTICE from '@/components/69_chapter3270humanjustice'
 import A0_CHAPTER3271ANTHRACENE from '@/components/70_chapter3271anthracene'
 import A1_CHAPTER3272UNDEAD from '@/components/71_chapter3272undead'
 import A2_CHAPTER3273DISGUISESUCCESSFUL from '@/components/72_chapter3273disguisesuccessful'
 import A3_CHAPTER3274THEARRIVALOFTHESPIRITMASTER from '@/components/73_chapter3274thearrivalofthespiritmaster'
 import A4_CHAPTER3275FALLENTREASURECHANNELS from '@/components/74_chapter3275fallentreasurechannels'
 import A5_CHAPTER3276POWER from '@/components/75_chapter3276power'
 import A6_CHAPTER3277STRONGSUPPORT from '@/components/76_chapter3277strongsupport'
 import A7_CHAPTER3278EASTWINDOW from '@/components/77_chapter3278eastwindow'
 import A8_CHAPTER3279TRUEORFALSEUNKNOWN from '@/components/78_chapter3279trueorfalseunknown'
 import A9_CHAPTER3280REFINEDTHUNDERPARTICLE from '@/components/79_chapter3280refinedthunderparticle'
 import A0_CHAPTER3281OILLAMP from '@/components/80_chapter3281oillamp'
 import A1_CHAPTER3282EVERYWHEREBLEMISH from '@/components/81_chapter3282everywhereblemish'
 import A2_CHAPTER3283THEREISNOTHINGTODO from '@/components/82_chapter3283thereisnothingtodo'
 import A3_CHAPTER3284WINDFILLEDBROTHEL from '@/components/83_chapter3284windfilledbrothel'
 import A4_CHAPTER3285PEOPLESHEARTS from '@/components/84_chapter3285peopleshearts'
 import A5_CHAPTER3286BIGBROTHERAPPEARS from '@/components/85_chapter3286bigbrotherappears'
 import A6_CHAPTER3287PERFECTION from '@/components/86_chapter3287perfection'
 import A7_CHAPTER3288FATHERANDDAUGHTER from '@/components/87_chapter3288fatheranddaughter'
 import A8_CHAPTER3289FAITH from '@/components/88_chapter3289faith'
 import A9_CHAPTER3290BUPROPION from '@/components/89_chapter3290bupropion'
 import A0_CHAPTER3291REAPPEARANCE from '@/components/90_chapter3291reappearance'
 import A1_CHAPTER3292ALCHEMICALBOTTLE from '@/components/91_chapter3292alchemicalbottle'
 import A2_CHAPTER3293HYACINTH from '@/components/92_chapter3293hyacinth'
 import A3_CHAPTER3294KINGSSUMMONINGORDER from '@/components/93_chapter3294kingssummoningorder'
 import A4_CHAPTER3295ULTIMATEAPPROACH from '@/components/94_chapter3295ultimateapproach'
 import A5_CHAPTER3296TOWER from '@/components/95_chapter3296tower'
 import A6_CHAPTER3297AWAGER from '@/components/96_chapter3297awager'
 import A7_CHAPTER3298SEDUM from '@/components/97_chapter3298sedum'
 import A8_CHAPTER3299GODLYAXE from '@/components/98_chapter3299godlyaxe'
 import A9_CHAPTER3300METACARPUS from '@/components/99_chapter3300metacarpus'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter3201surpriseattack",
 			"name" : "0_chapter3201surpriseattack",
 			"component" : A_CHAPTER3201SURPRISEATTACK
 		},
 		{
 			"path" : "/1_chapter3202bigprophecy",
 			"name" : "1_chapter3202bigprophecy",
 			"component" : A_CHAPTER3202BIGPROPHECY
 		},
 		{
 			"path" : "/2_chapter3203theappearanceofthegodemperor",
 			"name" : "2_chapter3203theappearanceofthegodemperor",
 			"component" : A_CHAPTER3203THEAPPEARANCEOFTHEGODEMPEROR
 		},
 		{
 			"path" : "/3_chapter3204regressivechalk",
 			"name" : "3_chapter3204regressivechalk",
 			"component" : A_CHAPTER3204REGRESSIVECHALK
 		},
 		{
 			"path" : "/4_chapter3205turnaround",
 			"name" : "4_chapter3205turnaround",
 			"component" : A_CHAPTER3205TURNAROUND
 		},
 		{
 			"path" : "/5_chapter3206dubioussinus",
 			"name" : "5_chapter3206dubioussinus",
 			"component" : A_CHAPTER3206DUBIOUSSINUS
 		},
 		{
 			"path" : "/6_chapter3207daughter",
 			"name" : "6_chapter3207daughter",
 			"component" : A_CHAPTER3207DAUGHTER
 		},
 		{
 			"path" : "/7_chapter3208thetruthisclear",
 			"name" : "7_chapter3208thetruthisclear",
 			"component" : A_CHAPTER3208THETRUTHISCLEAR
 		},
 		{
 			"path" : "/8_chapter3209difficultyinfeeling",
 			"name" : "8_chapter3209difficultyinfeeling",
 			"component" : A_CHAPTER3209DIFFICULTYINFEELING
 		},
 		{
 			"path" : "/9_chapter3210marchingformation",
 			"name" : "9_chapter3210marchingformation",
 			"component" : A_CHAPTER3210MARCHINGFORMATION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js